// Simple API client to replace Backbone.Model functionality
// Provides a simple interface to make AJAX requests similar to Backbone.Model

class ApiModel {
  constructor(urlRoot, attributes = {}) {
    this.urlRoot = urlRoot
    this.attributes = attributes
    this.id = attributes.id
  }

  set(key, value) {
    if (typeof key === 'object') {
      Object.assign(this.attributes, key)
    } else {
      this.attributes[key] = value
    }
  }

  get(key) {
    return this.attributes[key]
  }

  save(attributes = null, options = {}) {
    if (attributes) {
      this.set(attributes)
    }

    const url = this.id ? `${this.urlRoot}/${this.id}` : this.urlRoot
    const method = this.id ? 'PUT' : 'POST'

    const headers = {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector("meta[name='csrf-token']")?.getAttribute("content")
    }

    return fetch(url, {
      method: method,
      headers: headers,
      body: JSON.stringify(this.attributes)
    })
      .then(response => {
        if (response.ok) {
          if (options.success) {
            options.success(this, response)
          }
          return response
        } else {
          throw new Error('Request failed')
        }
      })
      .catch(error => {
        if (options.error) {
          options.error(this, error)
        }
        throw error
      })
  }

  fetch(options = {}) {
    const url = this.id ? `${this.urlRoot}/${this.id}` : this.urlRoot

    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        this.set(data)
        if (options.success) {
          options.success(this, data)
        }
        return data
      })
      .catch(error => {
        if (options.error) {
          options.error(this, error)
        }
        throw error
      })
  }
}

export default ApiModel
